export class UserNotFoundError extends Error {}
